import { GoodsRegardingsService } from "./../../../services/documents/GoodsRegardingsService";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { CreateGoodsRegardingsDto } from "../../../dtos/documents/GoodsRegardings/CreateGoodsregardingsDto";
import { NFLookupGoodsRegardings } from "../../../components/Shared/NewForms/NFLookupGoodsRegardings";
import {
  GoodsRegardingsDetail
} from "../../../components/Pages/Documents/Warehouse/GoodsRegradings/GoodsRegardingsDetail";
import GoodsRegardingsList from "../../../components/Pages/Documents/Warehouse/GoodsRegradings/GoodsRegardingsList";

export const GoodsRegardings: IAppEntity = {
  entityType: "document",
  title: "Goods Regardings",
  pluralTitle: "Goods Regardings",
  apiUrl: "GoodsRegradings",
  apiEnum: ReferenceTypes.DocumentGoodsRegrading,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(GoodsRegardingsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(GoodsRegardingsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupGoodsRegardings, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new GoodsRegardingsService("GoodsRegradings"),
  getEmptyModel: () => {
    const model: CreateGoodsRegardingsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      documentDate: new Date(),
      // documentNumber: ,
      status: 0,
      createdDate: new Date(),
      
      goodsRegradingGoodPostings: [],
      goodsRegradingGoodUnpostings: [],
    };
    return model;
  },
};
